module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBjc0xDoJAEAXQ+SsCpUewhK3wBnIDb2AoPQXegELB1hsYT7CJiLWlJUewI4o6spuYbAiF08xk3s8MqFdBpqbw3Kx5PBPHBpmpiLzxgYnJ92kibIDrKO5mRhvfVnFtMNiUcw0f4P4DvRdhcVmIETTUNhiEeC/1AOajDQbd5pV0/UpAKndVSkMVbk97WZz57wD6AZmXa/2iZcwGL8i8inT/Anc0RB837NaHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-arrow.png
// module id = Kiuh
// module chunks = 3